import * as React from 'react'
import { AppBar } from './components/AppBar'
import Auth from 'infrastructure/auth/Auth'
import { Notify } from 'shared/ui/Notify'
import { AppDrawer } from './components/AppDrawer'
import { AppContent } from './components/AppContent'
import { GlobalDialog } from 'shared/ui/GlobalDialog'

export default function AppLayout() {
  return (
    <>
      <Auth />
      <Notify />
      <GlobalDialog />
      <div>
        <div style={{ flexGrow: 1 }}>
          <AppBar />
          <AppDrawer />
          <AppContent />
        </div>
      </div>
    </>
  )
}
